import {
  IonAvatar,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonSkeletonText,
  IonThumbnail
} from '@ionic/react';

export const TeammatesLoading = () => (
  <IonItemGroup>
    <IonItemDivider color="light">
      <IonThumbnail slot="start" style={{ width: '24px', height: '24px' }}>
        <IonSkeletonText animated={true}></IonSkeletonText>
      </IonThumbnail>
      <IonSkeletonText
        animated={true}
        style={{ width: '250px' }}
      ></IonSkeletonText>
    </IonItemDivider>
    <IonItem>
      <IonAvatar slot="start">
        <IonSkeletonText animated={true}></IonSkeletonText>
      </IonAvatar>
      <IonLabel>
        <IonSkeletonText
          animated={true}
          style={{ width: '300px' }}
        ></IonSkeletonText>
      </IonLabel>
    </IonItem>
    <IonItem>
      <IonAvatar slot="start">
        <IonSkeletonText animated={true}></IonSkeletonText>
      </IonAvatar>
      <IonLabel>
        <IonSkeletonText
          animated={true}
          style={{ width: '500px' }}
        ></IonSkeletonText>
      </IonLabel>
    </IonItem>
    <IonItem>
      <IonAvatar slot="start">
        <IonSkeletonText animated={true}></IonSkeletonText>
      </IonAvatar>
      <IonLabel>
        <IonSkeletonText
          animated={true}
          style={{ width: '400px' }}
        ></IonSkeletonText>
      </IonLabel>
    </IonItem>
    <IonItem>
      <IonAvatar slot="start">
        <IonSkeletonText animated={true}></IonSkeletonText>
      </IonAvatar>
      <IonLabel>
        <IonSkeletonText
          animated={true}
          style={{ width: '300px' }}
        ></IonSkeletonText>
      </IonLabel>
    </IonItem>
    <IonItem>
      <IonAvatar slot="start">
        <IonSkeletonText animated={true}></IonSkeletonText>
      </IonAvatar>
      <IonLabel>
        <IonSkeletonText
          animated={true}
          style={{ width: '350px' }}
        ></IonSkeletonText>
      </IonLabel>
    </IonItem>
  </IonItemGroup>
);
